module.exports = __webpack_public_path__ + "static/img/72-2.8bf873c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/72-2.jpg
// module id = q47A
// module chunks = 0